import React, { Component } from 'react'
import { withTranslate } from 'react-redux-multilingual'
import { connect } from 'react-redux'

// import * as actions from '../../../../store/actions/index'

import {
  fetchCompanyOptions,
  fetchFormOptionsForAppraisal,
  fetchStructureOptionsForAppraisal,
  fetchLevelGroupOptionsForAppraisal,
  fetchOrganizationOptionsForAppraisal,
  fetchPositionOptionsForAppraisal,
  // fetchEmployeeOptionsForAppraisal,
  fetchAppraisalData,
  importAppraisalData,
  exportAppraisalData,
  fetchEmployeeOptions,
  clearFilteredAppraisalRecords,
  fetchAppraisalTypeOptionsForAppraisal,
  fetchAppraisalStatusOptionsForAppraisal,
  fetchDashboardPerformanceComparisonChartLine,
  fetchDashboardPerformanceComparisonChartBar,
  fetchDashboardPerformanceComparisonDataKpi,
  enqueueSnackbar
} from '../../../../store/actions'

import {
  extractFilterOptions,
  clearFilterOptionValues,
  updateFilterOptions,
  updateObject
} from '../../../../helpers/utils'

import Aux from '../../../../hoc/Auxiliary/Auxiliary'
import Alert from '../../../../components/Alert/Alert'
import ActionBar from '../../../../components/ActionBar/ActionBar'
import Card from '../../../../components/UI/Card/Card'
import CardHeader from '../../../../components/UI/Card/Header/Header'
import CardBody from '../../../../components/UI/Card/Body/Body'

import FilterModal from '../../../../components/FilterModal/FilterModal'
import Spinner from '../../../../components/UI/Spinner/Spinner'
import PleaseFilter from '../../../../components/PleaseFilter/PleaseFilter'
import PageInfo from '../../../../components/PageInfo/PageInfo'

import PerformanceComparisonContent from '../../../../components/PageContent/Dashboard/PerformanceComparison/PerformanceComparisonContent'

class PerformanceComparison extends Component {
  state = {
    // Filter Modal States
    filterModalOpen: false,
    filterControls: {
      company_id: {
        label: this.props.translate('company'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('company'),
          options: []
        },
        required: true
      },
      appraisal_type_id: {
        label: this.props.translate('appraisalType'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('appraisalType'),
          options: []
        },

        required: true
      },
      form_id: {
        label: this.props.translate('form'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('form'),
          options: []
        },
        required: true
      },
      structure_id: {
        label: this.props.translate('structure'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('structure'),
          options: []
        },
        required: true
      },
      level_group_id: {
        label: this.props.translate('levelGroup'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('levelGroup'),
          options: []
        },
        required: false
      },
      org_id: {
        label: this.props.translate('organization'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('organization'),
          options: []
        },
        required: false
      },
      position_id: {
        label: this.props.translate('position'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('position'),
          options: [],
          disabled: false
        },
        required: false
      },
      emp_id: {
        label: this.props.translate('employeeName'),
        value: '',
        configs: {
          placeholder: this.props.translate('select') + this.props.translate('employeeName'),
          options: [],
          disabled: false
        },
        required: false
      }
    },
    filterOptions: {
      appraisalTypeOptions: null,
      companyFilterOptions: null,
      appraisalTypeFilterOptions: null,
      formFilterOptions: null,
      structureFilterOptions: null,
      levelGroupFilterOptions: null,
      organizationFilterOptions: null,
      positionFilterOptions: null,
      empFilterOptions: null
    },

    // Import Modal States
    importModalOpen: false,
    importFile: null,

    // Presentational State
    appraisalType: null,
    company: null
  }

  componentDidMount = () => {
    // this.fetchData();
    this.props.fetchAppraisalTypeOptions()
    this.props.fetchCompanyOptions()

    if (this.props.filtered) {
      const { appraisalType, company } = this.props.filtered

      this.props.filterAppraisalRecords(this.props.filtered)

      this.setState({
        appraisalType,
        company
      })
    }
  }

  static getDerivedStateFromProps(props, state) {
    let updatedState = { ...state }
    if (props.filtered !== updatedState.filteredCache) {
      updatedState = { ...updatedState, filteredCache: props.filtered }
    }

    if (props.filterOptions.appraisalTypeOptions !== state.filterOptions.appraisalTypeOptions) {
      const appraisalTypeFilter = state.filterControls.appraisal_type_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.appraisalTypeOptions,
        appraisalTypeFilter,
        'appraisal_type_id',
        'appraisal_type_id',
        { name: 'appraisal_type_name', code: 'appraisal_type_code' },
        'Select Appraisal Type'
      )
      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.appraisal_type_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          appraisal_type_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          appraisalTypeOptions: props.filterOptions.appraisalTypeOptions
        }
      }
    }
    if (props.filterOptions.companyFilterOptions !== state.filterOptions.companyFilterOptions) {
      const companyFilter = state.filterControls.company_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.companyFilterOptions,
        companyFilter,
        'company_id',
        'company_id',
        { name: 'company_name', code: 'company_code' },
        'Select company'
      )
      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.company_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          company_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          companyFilterOptions: props.filterOptions.companyFilterOptions
        }
      }
    }
    if (props.filterOptions.formFilterOptions !== state.filterOptions.formFilterOptions) {
      const formFilter = state.filterControls.form_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.formFilterOptions,
        formFilter,
        'form_id',
        'form_id',
        'form_name',
        'Select Form'
      )
      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.form_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          form_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          formFilterOptions: props.filterOptions.formFilterOptions
        }
      }
    }
    if (props.filterOptions.structureFilterOptions !== state.filterOptions.structureFilterOptions) {
      const structureFilter = state.filterControls.structure_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.structureFilterOptions,
        structureFilter,
        'structure_id',
        'structure_id',
        'structure_name',
        'Select structure'
      )
      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.structure_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      const { structureFilterOptions } = props.filterOptions
      let defaultValue = ''
      if (structureFilterOptions && structureFilterOptions.length > 0) {
        const target = structureFilterOptions.find(s => s.structure_id === 1)
        if (target) {
          defaultValue = {
            key: target.structure_id,
            value: target.structure_id,
            label: target.structure_name
          }
        }
      }
      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          structure_id: {
            ...updatedFilterItem,
            value: defaultValue
          }
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          structureFilterOptions: props.filterOptions.structureFilterOptions
        }
      }
    }
    if (
      props.filterOptions.levelGroupFilterOptions !== state.filterOptions.levelGroupFilterOptions
    ) {
      const levelGroupFilter = state.filterControls.level_group_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.levelGroupFilterOptions,
        levelGroupFilter,
        'level_group_id',
        'level_group_id',
        'level_group_name',
        'Select level'
      )
      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.level_group_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          level_group_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          levelGroupFilterOptions: props.filterOptions.levelGroupFilterOptions
        }
      }
    }
    if (props.filterOptions.orgFilterOptions !== state.filterOptions.orgFilterOptions) {
      const orgFilter = state.filterControls.org_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.orgFilterOptions,
        orgFilter,
        'org_id',
        'org_id',
        { code: 'org_code', name: 'org_name' },
        'Select Organization'
      )
      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.org_id) ||
          null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { org_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          orgFilterOptions: props.filterOptions.orgFilterOptions
        }
      }
    }
    if (props.filterOptions.positionFilterOptions !== state.filterOptions.positionFilterOptions) {
      const positionFilter = state.filterControls.position_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.positionFilterOptions,
        positionFilter,
        'position_id',
        'position_id',
        { name: 'position_name', code: 'position_code' },
        'Select position'
      )

      let value = null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(
            item => item.value === props.filtered?.position_id
          ) || null
      }

      updatedFilterItem = { ...updatedFilterItem, value }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, {
          position_id: updatedFilterItem
        }),
        filterOptions: {
          ...updatedState.filterOptions,
          positionFilterOptions: props.filterOptions.positionFilterOptions
        }
      }
    }
    if (props.filterOptions.empFilterOptions !== state.filterOptions.empFilterOptions) {
      const employeeFilter = state.filterControls.emp_id
      let updatedFilterItem = updateFilterOptions(
        props.filterOptions.empFilterOptions,
        employeeFilter,
        'emp_id',
        'emp_id',
        { name: 'full_name', code: 'emp_id' },
        'Select employee'
      )

      const { filterControls } = state

      let value = filterControls.emp_id ? filterControls.emp_id.value : null
      if (props.filtered !== state.filteredCache) {
        value =
          updatedFilterItem.configs?.options?.find(item => item.value === props.filtered?.emp_id) ||
          null
      }

      updatedFilterItem = {
        ...updatedFilterItem,
        value
      }

      updatedState = {
        ...updatedState,
        filterControls: updateObject(updatedState.filterControls, { emp_id: updatedFilterItem }),
        filterOptions: {
          ...updatedState.filterOptions,
          empFilterOptions: props.filterOptions.empFilterOptions
        }
      }
    }

    return updatedState
  }

  // Cleaner Methods
  clearFilter = () => {
    const clearedFilter = clearFilterOptionValues(this.state.filterControls)
    this.setState({
      filterControls: clearedFilter,
      filteredCache: null
    })
  }

  closeFilterModal = filtered => {
    this.setState({
      filterModalOpen: false
    })
    if (!filtered) {
      this.clearFilter()
    }
  }

  // Filter Modal Methods
  openFilterModal = () => {
    this.setState({
      filterModalOpen: true
    })
  }

  filterChangedHandler = (itemKey, event) => {
    let value = event

    if (itemKey === 'appraisal_type_id') {
      const { label } = event
      const { filterControls } = this.state
      if (label.includes('Individual')) {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = false
        filterControls.position_id.required = false
        filterControls.emp_id.required = true

        filterControls.position_id.configs.disabled = false
        filterControls.emp_id.configs.disabled = false
      } else {
        filterControls.company_id.required = true
        filterControls.form_id.required = true
        filterControls.org_id.required = true
        filterControls.position_id.required = false
        filterControls.emp_id.required = false

        filterControls.position_id.configs.disabled = true
        filterControls.emp_id.configs.disabled = true
      }

      this.setState({
        filterControls
      })
    }

    const filterControls = { ...this.state.filterControls }
    const updatedItem = { ...filterControls[itemKey], value }
    const updatedFilterControls = updateObject(filterControls, { [itemKey]: updatedItem })

    const {
      appraisal_type_id,
      company_id,
      structure_id,
      level_group_id,
      org_id,
      position_id
    } = updatedFilterControls

    const filterOptions = {
      appraisal_type_id: appraisal_type_id?.value?.value,
      company_id: company_id?.value?.value,
      structure_id: structure_id?.value?.value,
      level_group_id: level_group_id?.value?.value,
      org_id: org_id?.value?.value,
      position_id: position_id?.value?.value
    }

    if (['company_id', 'appraisal_type_id'].includes(itemKey)) {
      this.props.fetchFormOptions(filterOptions)
      this.props.fetchStructureOptions(filterOptions)
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'structure_id') {
      this.props.fetchLevelGroupOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
      this.props.fetchStatusOptions(filterOptions)
    } else if (itemKey === 'level_group_id') {
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchOrgOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'org_id') {
      this.props.fetchPositionOptions(filterOptions)
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'position_id') {
      this.props.fetchEmployeeOptions(filterOptions)
    } else if (itemKey === 'emp_id') {
      if (updatedFilterControls.org_id.value === null) {
        let findEmp = this.props.filterOptions.empFilterOptions.find(
          item => item.emp_id === event.value
        )

        let org_id = findEmp.empdetails[0].org_id

        updatedFilterControls.org_id.value = updatedFilterControls.org_id.configs.options.find(
          item => item.value === org_id
        )
      }

      if (updatedFilterControls.position_id.value === null) {
        let findEmp = this.props.filterOptions.empFilterOptions.find(
          item => item.emp_id === event.value
        )
        let position_id = findEmp.empdetails[0].position_id

        updatedFilterControls.position_id.value = updatedFilterControls.position_id.configs.options.find(
          item => item.value === +position_id
        )
      }
    }

    this.setState({
      filterControls: updatedFilterControls
    })
  }

  filterRecords = () => {
    // const pageOptions = {
    //   perPage: this.props.pagination.perPage,
    //   page: this.props.pagination.currentPage
    // }
    // const filters = extractFilterOptions(this.state.filterControls, pageOptions)
    const filters = extractFilterOptions(this.state.filterControls)
    const appraisalType = this.state.filterControls.appraisal_type_id.value
    const company = this.state.filterControls.company_id.value
    this.setState({
      appraisalType: appraisalType,
      company: company
    })

    // this.props.filterAppraisalRecords({ ...filters, appraisalType, company });

    this.closeFilterModal(true)

    this.props.fetchDashboardPerformanceComparisonChartLine({
      ...filters,
      company_id: filters.company_id,
      org_id: filters.org_id,
      form_id: filters.form_id
    })

    this.props.fetchDashboardPerformanceComparisonChartBar({
      ...filters,
      company_id: filters.company_id,
      org_id: filters.org_id,
      form_id: filters.form_id
    })

    // this.fetchDashboardPerformanceComparisonChartLine()
  }

  render() {
    const { filterControls } = this.state

    let content = (
      <PerformanceComparisonContent
        lineChart={this.props.lineChart}
        tableData={this.props.tableData}
        barChart={this.props.barChart}
        percentChange={this.props.percentChange}
        filterControls={this.state.filterControls}
        dataKpi={this.props.dataKpi}
        fetchDashboardPerformanceComparisonDataKpi={param => {
          this.props.fetchDashboardPerformanceComparisonDataKpi(param)
        }}
        fetchDashboardPerformanceComparisonChartBar={param => {
          this.props.fetchDashboardPerformanceComparisonChartBar(param)
        }}
      />
    )

    if (!this.props.filtered) {
      content = <PleaseFilter />

      if (this.props.filterLoading === true) {
        content = <Spinner />
      }
    }

    return (
      <Aux>
        <Alert />
        <FilterModal
          open={this.state.filterModalOpen}
          filterControls={filterControls}
          filterSaved={this.filterRecords}
          filterChanged={this.filterChangedHandler}
          cancelled={this.closeFilterModal}
          loadingQueue={this.props.loadingQueue}
        />
        <Card>
          <CardHeader>
            <ActionBar
              filtering={this.openFilterModal}
              show={['filter']}
              leftContent={<PageInfo pageTranslateKey={'performanceComparison'} />}
            />
          </CardHeader>
          <CardBody>
            {content}
            {/* <PerformanceComparisonContent
              lineChart={this.props.lineChart}
              tableData={this.props.tableData}
              barChart={this.props.barChart}
              dataKpi={this.props.dataKpi}
              percentChange={this.props.percentChange}
              filterControls={this.state.filterControls}
              fetchDashboardPerformanceComparisonChartBar={param => {
                this.props.fetchDashboardPerformanceComparisonChartBar(param)
              }}
              fetchDashboardPerformanceComparisonDataKpi={param => {
                this.props.fetchDashboardPerformanceComparisonDataKpi(param)
              }}
            /> */}
          </CardBody>
        </Card>
      </Aux>
    )
  }
}

const mapStateToProps = state => {
  const {
    lineChart,
    tableData,
    barChart,
    percentChange,
    dataKpi,
    dataKpiLoading,
    filterLoading
  } = state.dashboardPerformanceComparison

  return {
    lineChart: lineChart,
    tableData: tableData,
    dataKpi: dataKpi,
    barChart: barChart,
    percentChange: percentChange,
    dataKpiLoading: dataKpiLoading,
    filterLoading: filterLoading,

    records: state.appraisal.records,
    pagination: state.appraisal.pagination,
    imported: state.appraisal.imported,
    loadingStates: state.appraisal.loadingStates,

    filtered: state.dashboardPerformanceComparison.filtered,

    filterOptions: {
      appraisalTypeOptions: state.dashboardPerformanceComparison.appraisalType,
      companyFilterOptions: state.dashboardPerformanceComparison.company,
      formFilterOptions: state.dashboardPerformanceComparison.form,
      structureFilterOptions: state.dashboardPerformanceComparison.structure,
      levelGroupFilterOptions: state.dashboardPerformanceComparison.levelGroup,
      orgFilterOptions: state.dashboardPerformanceComparison.org,
      positionFilterOptions: state.dashboardPerformanceComparison.position,
      empFilterOptions: state.dashboardPerformanceComparison.emp
    },
    loadingQueue: state.dashboardPerformanceComparison.loadingStates
  }
}

const mapDispatchToProps = dispatch => {
  return {
    // Alert
    fireAlert: alertOption => {
      dispatch(enqueueSnackbar(alertOption))
    },
    // Chart Line
    fetchDashboardPerformanceComparisonChartLine: filterOptions =>
      dispatch(fetchDashboardPerformanceComparisonChartLine(filterOptions)),
    // Chart Bar
    fetchDashboardPerformanceComparisonChartBar: filterOptions =>
      dispatch(fetchDashboardPerformanceComparisonChartBar(filterOptions)),
    // Data Kpi
    fetchDashboardPerformanceComparisonDataKpi: filterOptions =>
      dispatch(fetchDashboardPerformanceComparisonDataKpi(filterOptions)),
    // Filter
    fetchAppraisalTypeOptions: () => dispatch(fetchAppraisalTypeOptionsForAppraisal()),
    fetchCompanyOptions: () => dispatch(fetchCompanyOptions()),
    fetchFormOptions: filterOptions => dispatch(fetchFormOptionsForAppraisal(filterOptions)),
    fetchStructureOptions: filterOptions =>
      dispatch(
        fetchStructureOptionsForAppraisal({
          ...filterOptions,
          structure_type_code: ['STT01', 'STT04']
        })
      ),
    fetchLevelGroupOptions: filterOptions =>
      dispatch(fetchLevelGroupOptionsForAppraisal(filterOptions)),
    fetchOrgOptions: filterOptions => dispatch(fetchOrganizationOptionsForAppraisal(filterOptions)),
    fetchPositionOptions: filterOptions =>
      dispatch(fetchPositionOptionsForAppraisal(filterOptions)),
    fetchEmployeeOptions: filterOptions => dispatch(fetchEmployeeOptions(filterOptions)),
    fetchStatusOptions: filterOptions =>
      dispatch(fetchAppraisalStatusOptionsForAppraisal(filterOptions)),
    filterAppraisalRecords: filterOptions => dispatch(fetchAppraisalData(filterOptions)),
    importAppraisalData: () => dispatch(importAppraisalData()),
    exportAppraisalData: filterOptions => dispatch(exportAppraisalData(filterOptions)),
    clearFilteredAppraisalRecords: () => dispatch(clearFilteredAppraisalRecords())
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslate(PerformanceComparison))
